import { Box, Typography } from '@mui/material'

import { useAppTheme } from '@/theme/ThemeContext'

const NodeHeader = ({ title, icon }: { title: string; icon: string }) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  const colors = {
    text: isDarkMode ? '#B0B0B0' : '#8F98A5',
    border: isDarkMode ? '#374151' : 'rgba(50, 59, 119, 0.10)',
    iconFilter: 'none',
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        borderBottom: `1px solid ${colors.border}`,
        direction: 'rtl',
      }}
    >
      <img src={icon} alt={title} style={{ filter: colors.iconFilter }} />
      <Typography
        sx={{
          color: colors.text,
          textAlign: 'right',
          fontFamily: 'Rubik, sans-serif',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: 'normal',
        }}
      >
        {title}
      </Typography>
    </Box>
  )
}

export default NodeHeader
